<h2 mat-dialog-title> Create New Material </h2>
<mat-dialog-content>
  <form [formGroup]="materialForm" class="form">
    <mat-form-field class="form-element">
      <mat-label>Name</mat-label>
      <input matInput placeholder="Name" formControlName="name" [errorStateMatcher]="matcher">
      @if (materialForm.get('name').hasError('required')) {
        <mat-error>The field name is required</mat-error>
      }
      @if (materialForm.get('name').hasError('duplicateNames')) {
        <mat-error>This name is already used</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="greyBtn" mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" type="submit" class="button" data-testid="submit"
  [disabled]="!materialForm.valid" (click)="onSubmit(materialForm.value)"> Create </button>
</mat-dialog-actions>